// emailActions.js
import axios from 'axios';
// import Swal from 'sweetalert2';




// Action types
export const SET_LOADING = 'SET_LOADING';

export const setLoading = (isLoading) => ({
    type: SET_LOADING,
    payload: isLoading,
});





export const customerSuccessEmail = (emailData, navigate) => async (dispatch) => {
    console.log('customerSuccessEmail',emailData)
    dispatch(setLoading(true));
    try {
        const response = await axios.post(`https://api.thamesbankinsurance.co.uk/customeremail`, emailData, {headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Headers': 'Content-Type',
        }});
        console.log(response)
        navigate('tahnkyou/'+emailData.reference, { replace: true });
        dispatch(setLoading(false));
    } catch (error) {
        dispatch(setLoading(false));
        // Swal.fire({
        //     title: 'Error',
        //     text: error,
        //     icon: "error"
        // });
    }
};







export const customerFailedEmail = (emailData) => async (dispatch) => {
     console.log('customerFailedEmail',emailData)
    dispatch(setLoading(true));
    try {
        const response = await axios.post(`https://api.thamesbankinsurance.co.uk/customerfailureemail`, emailData, {headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Headers': 'Content-Type',
        }});
        dispatch(setLoading(false));
        if(response.data.status === 200){
            dispatch(setLoading(false));
        } else{
            console.log(response)
        }
        
    } catch (error) {
        dispatch(setLoading(false));
        console.log(error)
        // Swal.fire({
        //     title: 'Error',
        //     text: error,
        //     icon: "error"
        // });
    }
};




export const brokerSuccessEmail = (brokerEmailData) => async (dispatch) => {
    console.log('brokerSuccessEmail',brokerEmailData)
    dispatch(setLoading(true));
    try {
        const response = await axios.post(`https://api.thamesbankinsurance.co.uk/brokeremail`, brokerEmailData, {headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Headers': 'Content-Type',
        }});
        console.log('brokerSuccessEmailrrrrr',response)
        // navigate('tahnkyou/'+brokerEmailData.reference, { replace: true });
        dispatch(setLoading(false));
    } catch (error) {
        dispatch(setLoading(false));
        // Swal.fire({
        //     title: 'Error',
        //     text: error,
        //     icon: "error"
        // });
    }
};







export const brokerFailedEmail = (brokerEmailData) => async (dispatch) => {
    console.log('brokerFailedEmail',brokerEmailData)
    dispatch(setLoading(true));
    try {
        const response = await axios.post(`https://api.thamesbankinsurance.co.uk/brokerfailureemail`, brokerEmailData, {headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Headers': 'Content-Type',
        }});
        console.log(response)
        // navigate('tahnkyou/'+brokerEmailData.reference, { replace: true });
        dispatch(setLoading(false));
    } catch (error) {
        dispatch(setLoading(false));
        // Swal.fire({
        //     title: 'Error',
        //     text: error,
        //     icon: "error"
        // });
    }
};